import React from "react";
import Header from "../../components/Header.jsx";
import Footer from "../../components/Footer.jsx";
import "../../styles/pages/subpages/contacts_page.css";

import ChevronRightIcon from "../../assets/icons/chevron-right.svg";

import PhoneIcon from "../../assets/icons/phone-icon.svg";
import AtIcon from "../../assets/icons/at-icon.svg";

const ContactsPage = () => {
  return (
    <div className="contacts-page">
      <Header />
      <nav className="page-nav">
        <a href="/" className="nav-link">
          Главная
        </a>
        <img
          src={ChevronRightIcon}
          alt="Chevron"
          className="nav-chevron-icon"
        />
        <a href="/about_company" className="nav-link">
          О компании
        </a>
        <img
          src={ChevronRightIcon}
          alt="Chevron"
          className="nav-chevron-icon"
        />
        <span className="nav-link">Контакты</span>
      </nav>

      <div className="contacts-page-content">
        <h2 className="gradient-page-title">Контакная информация</h2>
        <div className="contact-block contacts-page-contact-block">
          <h3 className="contact-title">Юридический адрес и адрес офиса компании:</h3>
          <div className="contact-content">
            <div className="contact-content-info-wrapper">
              <span className="contact-info">Общество с ограниченной ответственностью "ШНОС"</span>
              <span className="contact-info">Кыргызская республика, г. Бишкек <br /> 720011, ул. Абдрахманова 201/1</span>
            </div>
            <div className="contact-item">
              <img src={PhoneIcon} alt="Phone Icon" className="icon" />
              <span className="contact-text">тел.: <span className="number">+996 (312) 303 303</span></span>
            </div>
            <div className="contact-item">
              <span className="contact-text">факс.: <span className="number">+996 (312) 303 303</span></span>
            </div>
          </div>
        </div>

        <div className="contact-block contacts-page-contact-block">
          <h3 className="contact-title">Номер горячей линий</h3>
          <div className="contact-content">
            <div className="contact-item">
              <img src={PhoneIcon} alt="Phone Icon" className="icon" />
              <span className="contact-text">тел.: <u className="number">+996 (557) 29 49 49</u> (круглосуточный)</span>
            </div>
          </div>
        </div>

        <div className="contact-block contacts-page-contact-block">
          <h3 className="contact-title">По вопросам касающихся конкурсных торгов и государственных закупок:</h3>
          <div className="contact-content">
            <div className="contact-item">
              <img src={PhoneIcon} alt="Phone Icon" className="icon" />
              <span className="contact-text">тел.: <span className="number">+996 (312) 303 303</span>, (доб. 138)</span>
            </div>
            <div className="contact-item">
              <span className="contact-text">тел.: <span className="number">+996 (556) 706 146</span></span>
            </div>
            <div className="contact-item">
              <span className="contact-text">тел.: <span className="number">+996 (700) 706 146</span></span>
            </div>
            <div className="contact-item">
              <span className="contact-text">тел.: <span className="number">+996 (700) 706 146</span></span>
            </div>
            <div className="contact-item">
              <img src={AtIcon} alt="Email Icon" className="icon" />
              <span className="contact-text">эл. адрес: <u className="email">tender@bpetroleum.kg</u></span>
            </div>
          </div>
        </div>

        <div className="contact-block contacts-page-contact-block">
          <h3 className="contact-title">Отдел кадров</h3>
          <div className="contact-content">
            <div className="contact-item contact-with-margin">
              <img src={PhoneIcon} alt="Phone Icon" className="icon" />
              <span className="contact-text">тел.: <span className="number">+996 312 303 303</span>, (доб. 131)</span>
            </div>
            <div className="contact-item">
              <img src={AtIcon} alt="Email Icon" className="icon" />
              <span className="contact-text">эл. адрес: <u className="email">hr@bpetroleum.kg</u></span>
            </div>
          </div>
        </div>

        <div className="contact-block contacts-page-contact-block">
          <h3 className="contact-title">Отдел маркетинга и рекламы</h3>
          <div className="contact-content">
            <div className="contact-item contact-with-margin">
              <img src={PhoneIcon} alt="Phone Icon" className="icon" />
              <span className="contact-text">тел.: <span className="number">+996 312 303 303</span>, (доб. 124)</span>
            </div>
            <div className="contact-item">
              <img src={AtIcon} alt="Email Icon" className="icon" />
              <span className="contact-text">эл. адрес: <u className="email">marketing@bpetroleum.kg</u></span>
            </div>
          </div>
        </div>

        <div className="contact-block contacts-page-contact-block">
          <h3 className="contact-title">Отдел продаж корпоративным клиентам:</h3>
          <div className="contact-content">
            <div className="contact-item">
              <img src={PhoneIcon} alt="Phone Icon" className="icon" />
              <span className="contact-text">тел.: <span className="number">+996 (312) 303 303</span></span>
            </div>
            <div className="contact-item">
              <span className="contact-text">тел.: <span className="number">+996 (312) 303 303</span>, (доб. 114)</span>
            </div>
            <div className="contact-item">
              <span className="contact-text">тел.: <span className="number">+996 (555) 706 146</span></span>
            </div>
            <div className="contact-item">
              <span className="contact-text">тел.: <span className="number">+996 (700) 706 146</span></span>
            </div>
            <div className="contact-item">
              <img src={AtIcon} alt="Email Icon" className="icon" />
              <span className="contact-text">эл. адрес: <u className="email">talon@bpetroleum.kg</u></span>
            </div>
          </div>
        </div>

      </div>
      <Footer />
    </div>
  );
};

export default ContactsPage;
